<template>
  <label
    ref="btn"
    class="uploader-btn"
    @click="handleClick"
    :class="options.disabled ? 'uploader-btn-disabled' : ''"
  >
    <i class="el-icon-upload mr-5"></i>
    {{ uploadBtnText }}
  </label>
</template>

<script>
import { each, extend } from "./utils";

export default {
  name: "uploader-btn",
  inject: ["uploader"],
  props: {
    options: {
      type: Object,
      default() {
        return {
          disabled: false,
          autoStart: true,
          singleFile: false,
          buttonText: "",
          accept: "xls"
        };
      }
    }
  },
  watch: {
    "options.accept": {
      handler() {
        this.initFileInput();
      },
      immediate: true
    }
  },
  computed: {
    uploadBtnText() {
      const accept = this.options.accept;
      const xls = "选择 Excel 文件上传";
      const zip = "选择 Zip 文件上传";
      if (this.options.buttonText) {
        return this.options.buttonText;
      }
      return accept === "xls" ? xls : zip;
    }
  },
  methods: {
    handleClick(e) {
      if (this.options.disabled) {
        e.preventDefault();
      }
    },

    initFileInput() {
      const domNodes = this.$refs.btn;
      const isDirectory = false;
      const singleFile = this.options.singleFile;
      const accept = this.options.accept == "zip" ? ".zip" : ".xlsx, .xls";

      this.$nextTick(() => {
        // this.assignBrowse(domNodes, isDirectory, singleFile, { accept });
        this.assignBrowse(domNodes, isDirectory, singleFile);
      });
    },

    assignBrowse(domNodes, isDirectory, singleFile, attributes) {
      if (!domNodes || this.options.disabled) return;
      const _this = this.uploader.uploader;
      if (typeof domNodes.length === "undefined") {
        domNodes = [domNodes];
      }

      each(
        domNodes,
        domNode => {
          var input;
          if (domNode.tagName === "INPUT" && domNode.type === "file") {
            input = domNode;
          } else {
            const childNodes = domNode.childNodes;
            each(childNodes, childNode => {
              if (childNode.nodeName === "INPUT") {
                childNode.parentNode.removeChild(childNode);
              }
            });

            input = document.createElement("input");
            input.setAttribute("type", "file");
            extend(input.style, {
              visibility: "hidden",
              position: "absolute",
              width: "1px",
              height: "1px"
            });
            domNode.appendChild(input);
            domNode.addEventListener(
              "click",
              e => {
                if (domNode.tagName.toLowerCase() === "label") {
                  return;
                }
                input.click();
              },
              false
            );
          }
          if (!_this.opts.singleFile && !singleFile) {
            input.setAttribute("multiple", "multiple");
          }
          if (isDirectory) {
            input.setAttribute("webkitdirectory", "webkitdirectory");
          }
          attributes &&
            each(attributes, function(value, key) {
              input.setAttribute(key, value);
            });
          input.addEventListener(
            "change",
            function(e) {
              _this._trigger(e.type, e);
              if (e.target.value) {
                _this.addFiles(e.target.files, e);
                e.target.value = "";
              }
            },
            false
          );
        },
        _this
      );
    }
  },
  mounted() {
    this.initFileInput();
  }
};
</script>

<style>
.uploader-btn {
  display: inline-block;
  position: relative;
  padding: 4px 8px;
  font-size: 100%;
  line-height: 1.4;
  color: #666;
  border: 1px solid #666;
  cursor: pointer;
  border-radius: 2px;
  background: none;
  outline: none;
}
.uploader-btn:hover {
  background-color: rgba(0, 0, 0, 0.08);
}
.uploader-btn-disabled {
  background: #ebebeb;
  border: 1px solid #ebebeb;
}
.uploader-btn-disabled:hover {
  cursor: not-allowed;
}
</style>
